import React, { useEffect, useState } from 'react';
import { Dialog, Grid } from '@material-ui/core';
import api from '../../../../_core/api';
import { failure, success } from '../../../../_core/services/toast';
import { Button, Form, Input, Select, Option } from '../../../../_core/_components';
import { TipoDocumentoItem, Shopping } from './types';

import * as S from '../styles';

type Props = {
  onClose: () => void;
  onFinishSave: () => void;
  selectedRegister?: TipoDocumentoItem | null;
  modulos: any[];
};

const Modal: React.FC<Props> = ({ onClose, selectedRegister, onFinishSave, modulos }: Props) => {
  const [loading, setLoading] = useState(false);
  const [shoppingOptions, setShoppingOptions] = useState<Option[]>([]);
  const [selectedShoppings, setSelectedShoppings] = useState<Option[]>([]);
  const [observacao, setObservacao] = useState('');
  const [name, setName] = useState('');
  const [selectedModulos, setSelectedModulos] = useState<Option[]>([]);

  useEffect(() => {
    if (!selectedRegister) {
      resetModalState();
    } else {
      setSelectedShoppings(selectedRegister.shoppings.map(s => ({ label: s.nome, value: s.id })));
      setSelectedModulos(selectedRegister.modulos.map(s => ({ label: s.nome, value: s.id })));
      setObservacao(selectedRegister.observacao);
      setName(selectedRegister.tipo);
    }
    getShoppingsOptions();
  }, [selectedRegister]);

  const getShoppingsOptions = async () => {
    const { data } = await api.get<Shopping[]>('/empresas/shoppings/simple-umpaged');
    const options: Option[] = data.map(s => ({
      label: s.nome,
      value: s.id,
    }));
    setShoppingOptions(options);
  };

  const resetModalState = () => {
    setSelectedShoppings([]);
    setSelectedModulos([]);
    setObservacao('');
    setName('');
  };

  const save = async () => {
    setLoading(true);
    const payload = {
      tipo: name || selectedRegister?.tipo,
      ativo: true,
      observacao: observacao || selectedRegister?.observacao,
      shoppings:
        selectedShoppings.map(s => ({
          id: s.value,
        })) || selectedRegister?.shoppings,
      modulos:
        selectedModulos.map(m => ({
          id: m.value,
        })) || selectedRegister?.modulos,
    };

    if (selectedRegister) {
      try {
        await api.post(`/config/excecoes/tipo-documento/${selectedRegister.id}`, payload);
        success('Atualizado com sucesso.');
        setLoading(false);
        resetModalState();
        onFinishSave();
      } catch (e) {
        failure('Erro ao tentar atualizar registro.');
        setLoading(false);
      }
    } else {
      try {
        await api.post('/config/excecoes/tipo-documento', payload);
        success('Criado com sucesso.');
        setLoading(false);
        resetModalState();
        onFinishSave();
      } catch (e) {
        failure('Erro ao tentar criar registro.');
        setLoading(false);
      }
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <S.ModalTop>
        <S.ModalTittle> {!selectedRegister ? 'Adicionar' : 'Editar'} </S.ModalTittle>
      </S.ModalTop>

      <Grid>
        <Form
          items={[
            <Input label="Tipo Documento" state={[name, setName]} />,
            <Input label="Observações" state={[observacao, setObservacao]} />,
            <Select
              state={[selectedShoppings, setSelectedShoppings]}
              options={shoppingOptions}
              placeholder="Shoppings"
            />,
            <Select
              state={[selectedModulos, setSelectedModulos]}
              options={modulos.map(e => ({ value: e.id, label: e.nome }))}
              placeholder="Módulos"
            />,
          ]}
        />
        <S.ModalActions>
          <Button onClick={save} text="Salvar" disabled={loading} />
        </S.ModalActions>
      </Grid>
    </Dialog>
  );
};

export default Modal;
